import { render, staticRenderFns } from "./03_Bauen.vue?vue&type=template&id=04ddab42&"
import script from "./03_Bauen.vue?vue&type=script&lang=js&"
export * from "./03_Bauen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports